<div class="text-xs">
  <form [formGroup]="moveForm" class="p-fluid" novalidate>

    <p-fieldset [legend]="targetLevel | titlecase" class="col-12">
      <div class="p-field mb-2">
        <label for="target">Move the item to the following {{ labelText }}:</label>
        <br />
        <p-treeSelect
          id="target"
          containerStyleClass="w-full"
          [(ngModel)]="selectedNode"
          [ngModelOptions]="{standalone: true}"
          [options]="treeItems"
          [placeholder]="'Select a ' + labelText"
          display="chip"
          selectionMode="single"
          filter="true"
          filterBy="data.label"
          appendTo="body"
          (onNodeSelect)="onNodeSelect($event.node)"
          (onClear)="onNodeClear()"
        >
          <ng-template pTemplate="default" let-node>
            <span class="flex items-center gap-2">
              @if (node?.data?.icon) {
                <img
                  class="level-icon"
                  [src]="node?.data?.icon"
                  alt="icon"
                  style="width: 16px; height: 16px;"
                />
              }
              {{ node?.data?.label }}
            </span>
          </ng-template>
          <ng-template let-node pTemplate="value">
            @if (!node) {
              <div>Select a {{ labelText }}</div>
            }
            @if (node) {
              <div>{{ node?.data?.label || node?.label }}</div>
            }
          </ng-template>
        </p-treeSelect>
      </div>
    </p-fieldset>
  </form>
</div>


<div style="float: right" class="pt-2 space-x-2">
  <p-button
    label="Cancel"
    (onClick)="onCancel()"
    severity="secondary"
    size="small"
    severity="danger"
    outlined
  ></p-button>
  <p-button
    label="Save"
    (onClick)="onSave()"
    [disabled]="moveForm.invalid"
    size="small"
    severity="success"
    outlined
  ></p-button>
</div>
